(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-buybox-cards-toggle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('huron-tier-buybox')) {
  customElements.define('huron-tier-buybox', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('[data-tier]')];
      this.cta = this.querySelector('.lpbb__cta');
      this.label = this.cta.textContent;
      this.error = this.querySelector('[data-error]');
      this.busy = false;
      this.cards.forEach(card => this.renderMode(card));
      this.addEventListener('change', event => {
        if (event.target.matches('.lpbb__tier-radio')) this.select(event.target.value);
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-full]');
        if (thumb) {
          const img = this.querySelector('.lpbb__main-image img');
          if (img) img.src = thumb.dataset.full;
          this.querySelectorAll('[data-full]').forEach(el => el.classList.toggle('is-active', el === thumb));
        }
      });
      this.cta.addEventListener('click', () => this.add());
      this.select(this.dataset.defaultOption);
    }
    renderMode(card) {
      const mode = card.dataset.mode;
      card.querySelectorAll('[data-price-mode]').forEach(el => { el.hidden = el.dataset.priceMode !== mode; });
      card.querySelectorAll('[data-sub-only]').forEach(el => { el.hidden = mode !== 'sub'; });
      card.querySelector('.lpbb__tier-radio').disabled = this.busy;
    }
    select(tier) {
      this.selected = this.cards.find(card => card.dataset.tier === tier) || this.cards[0];
      this.cards.forEach(card => {
        card.classList.toggle('is-selected', card === this.selected);
        card.querySelector('.lpbb__tier-radio').checked = card === this.selected;
      });
      this.error.hidden = true;
      this.update();
      this.gallery(this.selected.dataset.tier);
    }
    update() {
      const data = this.selected.dataset;
      const missing = !data.variant;
      const sold = !missing && data.available !== 'true';
      const validMode = data[data.mode + 'Ok'] === 'true';
      this.valid = !missing && !sold && validMode;
      this.cta.disabled = this.busy || !this.valid;
      this.cta.textContent = this.busy ? this.dataset.adding : missing ? this.dataset.missing : sold ? this.dataset.soldOut : !validMode ? this.dataset.unavailable : this.label;
      this.cta.setAttribute('aria-busy', String(this.busy));
      this.cards.forEach(card => this.renderMode(card));
    }
    gallery(tier) {
      let gallery;
      try { gallery = JSON.parse(this.dataset[tier + 'Gallery']); } catch { return; }
      const holder = this.querySelector('.lpbb__main-image');
      let img = holder.querySelector('img');
      if (gallery.main) {
        if (!img) { img = document.createElement('img'); img.width = 1200; img.height = 1200; holder.append(img); }
        img.src = gallery.main;
        img.alt = this.selected.querySelector('.lpbb__title').textContent;
        img.hidden = false;
      } else if (img) img.hidden = true;
      const thumbs = this.querySelector('.lpbb__thumbs');
      const urls = gallery.thumbs || [];
      thumbs.replaceChildren();
      thumbs.style.display = urls.length > 1 ? '' : 'none';
      urls.forEach((url, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'lpbb__thumb' + (index === 0 ? ' is-active' : '');
        button.dataset.full = url; button.setAttribute('aria-label', String(index + 1));
        const picture = document.createElement('img');
        picture.src = url; picture.alt = ''; picture.loading = 'lazy'; picture.width = 300; picture.height = 300;
        button.append(picture); thumbs.append(button);
      });
    }
    async add() {
      if (this.busy || !this.valid) return;
      const data = this.selected.dataset;
      const item = {id: Number(data.variant), quantity: Number(data.qty)};
      if (data.mode === 'sub') {
        if (!data.plan) return;
        item.selling_plan = Number(data.plan);
      }
      this.busy = true;
      this.error.hidden = true;
      this.update();
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:[item]})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorText);
        if (this.dataset.skipCart === 'true') { window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout'); return; }
        try {
          if (typeof window.upcartRefreshCart !== 'function' || typeof window.upcartOpenCart !== 'function') throw new Error();
          await window.upcartRefreshCart();
          await window.upcartOpenCart();
        } catch { window.location.assign(this.dataset.cartUrl); }
      } catch (error) {
        this.error.textContent = error.message || this.dataset.errorText;
        this.error.hidden = false;
      } finally { this.busy = false; this.update(); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-clean-otp-sns-buy-box"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('huron-clean-buybox')) {
  customElements.define('huron-clean-buybox', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-hcb-data]').textContent);
      this.strings = this.querySelector('[data-translations]').dataset;
      this.offer = this.data.offers.find(o => o.variants.length);
      this.onChange = this.change.bind(this);
      this.onSubmit = this.submit.bind(this);
      this.onGalleryClick = this.galleryClick.bind(this);
      this.addEventListener('click', this.onGalleryClick);
      this.addEventListener('change', this.onChange);
      this.querySelector('form').addEventListener('submit', this.onSubmit);
      if (!this.offer) { this.querySelector('[data-submit]').textContent = this.strings.unavailable; return; }
      const radio = this.querySelector('[data-offer][value="' + this.offer.id + '"]');
      if (radio) radio.checked = true;
      this.loadOffer();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onGalleryClick);
      this.querySelector('form')?.removeEventListener('submit', this.onSubmit);
      this.ready = false;
    }
    el(selector) { return this.querySelector(selector); }
    money(amount) { return new Intl.NumberFormat(this.data.locale || 'en', {style:'currency', currency:this.data.currency || 'USD', minimumFractionDigits:amount % 100 ? 2 : 0}).format(amount / 100); }
    change(event) {
      if (event.target.matches('[data-offer]')) {
        this.offer = this.data.offers.find(o => o.id === event.target.value);
        this.loadOffer();
      } else if (event.target.matches('[data-variant]')) {
        this.variant = this.offer.variants.find(v => String(v.id) === event.target.value);
        this.loadPlans();
      } else if (event.target.matches('[data-purchase]')) this.update();
    }
    loadOffer() {
      const selector = this.el('[data-variant-pills]');
      this.offer.variants = this.offer.variants.filter(v => Object.hasOwn(this.data.scents, v.title));
      selector.replaceChildren(...this.offer.variants.map(v => {
        const label = document.createElement('label');
        label.className = 'hcb__scent-pill';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'scent-' + this.id;
        input.value = String(v.id);
        input.setAttribute('data-variant', '');
        const text = document.createElement('span');
        text.textContent = this.data.scentLabels[v.title] || v.title;
        label.append(input, text);
        return label;
      }));
      this.variant = this.offer.variants.find(v => String(v.id) === String(this.offer.initialVariant)) || this.offer.variants[0];
      if (!this.variant) { this.el('[data-submit]').disabled = true; this.el('[data-submit]').textContent = this.strings.unavailable; return; }
      this.el('[data-variant][value="' + this.variant.id + '"]').checked = true;
      this.el('[data-product-title]').textContent = this.offer.title;
      this.el('[data-image-caption]').textContent = this.offer.caption || '';
      this.el('[data-gift-title]').textContent = this.offer.gift;
      this.el('[data-purchase][value="sub"]').checked = true;
      this.loadPlans();
    }
    loadPlans() {
      this.plan = this.variant.plans.find(p => {
        const cadence = (p.cadence || p.name || '').trim().toLowerCase().replace(/\s+/g, ' ');
        return /^(every )?60 days?$/.test(cadence);
      });
      const plan = this.plan;
      this.el('[data-sub-card]').hidden = !plan;
      this.el('[data-purchase][value="sub"]').disabled = !plan;
      this.el('[data-once-card]').hidden = this.variant.requiresPlan;
      this.el('[data-purchase][value="once"]').disabled = this.variant.requiresPlan;
      if (!plan && !this.variant.requiresPlan) this.el('[data-purchase][value="once"]').checked = true;
      if (plan && this.variant.requiresPlan) this.el('[data-purchase][value="sub"]').checked = true;
      this.update();
    }
    update() {
      const plan = this.plan;
      const sub = this.el('[data-purchase]:checked')?.value === 'sub';
      this.el('[data-variant-id]').value = String(this.variant.id);
      this.el('[data-scent-description]').textContent = this.data.scents[this.variant.title] || '';
      const planInput = this.el('[data-plan-id]');
      planInput.disabled = !sub || !plan;
      planInput.value = sub && plan ? String(plan.id) : '';
      this.el('[data-sub-card]').classList.toggle('is-selected', sub);
      this.el('[data-once-card]').classList.toggle('is-selected', !sub);
      this.el('[data-perks]').hidden = !sub;
      this.el('[data-once-price]').textContent = this.money(this.variant.price);
      if (plan) {
        this.el('[data-sub-price]').textContent = this.money(plan.price);
        const last = plan.adjustments?.at(-1)?.price ?? plan.price;
        const count = plan.rules?.[0]?.order_count;
        const after = plan.adjustments?.length > 1 && count ? this.strings.after.replace('{count}', count) + ' ' : '';
        this.el('[data-renewal]').textContent = after + this.strings.renewal.replace('{price}',this.money(last)).replace('{cadence}',plan.name.toLowerCase()) + ' ' + this.strings.tax;
      }
      const imageKey = this.offer.id + '-' + this.variant.id;
      if (this.galleryKey !== imageKey) {
        this.galleryKey = imageKey;
        this.buildGallery();
      }
      const valid = this.variant.available && (sub ? !!plan : !this.variant.requiresPlan);
      const button = this.el('[data-submit]');
      button.disabled = !valid || !!this.busy;
      button.textContent = valid ? (sub ? this.strings.subscribe : this.strings.once) + ' — ' + this.money(sub ? plan.price : this.variant.price) : this.strings.unavailable;
      this.el('[data-availability]').textContent = !plan ? this.strings.noSub : this.variant.requiresPlan ? this.strings.subOnly : '';
      this.el('[data-error]').hidden = true;
      this.el('[data-status]').textContent = '';
    }
    buildGallery() {
      const src = this.variant.image || this.offer.image;
      this.galleryImages = [
        ...(src ? [{src, alt:this.offer.title + ' — ' + this.variant.title}] : []),
        ...(this.data.gallery || [])
      ];
      this.el('[data-gallery]').hidden = this.galleryImages.length < 2;
      this.el('[data-thumbnails]').replaceChildren(...this.galleryImages.map((image, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'hcb__thumbnail';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label', this.strings.imageLabel.replace('{number}', index + 1) + ': ' + image.alt);
        button.setAttribute('aria-pressed', String(index === 0));
        const thumbnail = document.createElement('img');
        thumbnail.src = image.src;
        thumbnail.alt = '';
        thumbnail.width = 120;
        thumbnail.height = 120;
        thumbnail.loading = 'lazy';
        button.append(thumbnail);
        return button;
      }));
      this.showImage(0);
    }
    galleryClick(event) {
      const button = event.target.closest('[data-gallery-index],[data-gallery-prev],[data-gallery-next]');
      if (!button || !this.contains(button) || !this.galleryImages?.length) return;
      const index = button.hasAttribute('data-gallery-index') ? Number(button.dataset.galleryIndex) : this.galleryIndex + (button.hasAttribute('data-gallery-prev') ? -1 : 1);
      this.showImage(index);
      const active = this.el('[data-gallery-index="' + this.galleryIndex + '"]');
      if (active) {
        const strip = this.el('[data-thumbnails]');
        strip.scrollTo({left:active.offsetLeft - strip.offsetLeft,behavior:'auto'});
      }
    }
    showImage(index) {
      const image = this.el('[data-image]');
      if (!this.galleryImages.length) { image.hidden = true; return; }
      this.galleryIndex = (index + this.galleryImages.length) % this.galleryImages.length;
      const selected = this.galleryImages[this.galleryIndex];
      image.src = selected.src;
      image.alt = selected.alt;
      image.hidden = false;
      this.querySelectorAll('[data-gallery-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.galleryIndex) === this.galleryIndex)));
      this.el('[data-gallery-count]').textContent = (this.galleryIndex + 1) + ' / ' + this.galleryImages.length;
    }
    async submit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy || this.el('[data-submit]').disabled) return;
      this.busy = true;
      this.el('[data-submit]').disabled = true;
      this.el('[data-submit]').setAttribute('aria-busy','true');
      this.el('[data-status]').textContent = this.strings.adding;
      this.el('[data-error]').hidden = true;
      try {
        const form = new FormData(event.target);
        form.delete('purchase-' + this.id.replace('HuronCleanBuyBox-',''));
        const campaign = document.body.dataset.campaign;
        if (campaign) form.set('properties[_custom_campaign]',campaign);
        const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:form});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.strings.error);
        this.el('[data-status]').textContent = this.strings.added;
        const cart = this.dataset.cartUrl;
        window.location.assign(this.dataset.checkout === 'true' ? cart.replace(/\/cart\/?$/, '/checkout') : cart);
      } catch(error) {
        this.el('[data-error]').textContent = error.message || this.strings.error;
        this.el('[data-error]').hidden = false;
        this.el('[data-status]').textContent = '';
        this.busy = false;
        this.el('[data-submit]').disabled = false;
        this.el('[data-submit]').removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-huron-scent-buybox"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('huron-scent-buybox')) {
 customElements.define('huron-scent-buybox', class extends HTMLElement {
  connectedCallback() {
   if(this.ready)return;this.ready=true;
   this.data=JSON.parse(this.querySelector('[data-config]').textContent);this.s=this.data.settings;
   this.el('[data-supply]').hidden=this.s.show_supply===false;
   this.allOffers=this.data.offers.filter(o=>o.onceProducts.some(Boolean)||o.subProducts.some(Boolean));
   const initial=this.allOffers[0];
   this.factor=this.s.default_format&&this.s.default_format!=='first'?this.s.default_format:this.offerFormat(initial);
   this.offer=this.formatOffers()[0];this.scent=this.data.scents[0];this.mode=this.s.default_purchase||'once';
   this.el('[data-formats]').hidden=this.s.show_form_factor!==true;
   if(this.s.show_form_factor===true){const supply=this.el('[data-supply]');supply.before(this.el('.hcb__scents'),this.el('[data-formats]'));}
   this.syncFormatControls();
   this.controller=new AbortController();const opt={signal:this.controller.signal};
   this.addEventListener('change',e=>this.change(e),opt);this.addEventListener('click',e=>this.click(e),opt);
   this.el('[data-form]').addEventListener('submit',e=>this.submit(e),opt);
   if(!this.offer||!this.scent){this.el('[data-submit]').textContent=this.s.unavailable;return;}
   this.rebuild();
  }
  offerFormat(offer){return offer?.settings.form_factor||'bar_soap';}
  formatOffers(factor=this.factor){
   const offers=this.allOffers.filter(o=>this.offerFormat(o)===factor);
   return this.s.show_supply===false?offers.slice(0,1):offers;
  }
  syncFormatControls(){
   const active=this.formatOffers();
   this.querySelectorAll('[data-offer]').forEach(input=>{input.closest('label').hidden=!active.some(o=>o.id===input.value);input.checked=input.value===this.offer?.id;});
   this.querySelectorAll('[data-format]').forEach(input=>{
    const configured=this.formatOffers(input.value).length>0;
    input.checked=input.value===this.factor;input.disabled=!!this.busy||!configured;
    input.closest('label').classList.toggle('is-unavailable',!configured);
   });
  }
  selectFormat(factor){
   const candidates=this.formatOffers(factor);if(!candidates.length)return;
   const key=this.offer?.settings.supply_key||'single';
   this.factor=factor;this.offer=candidates.find(o=>(o.settings.supply_key||'single')===key)||candidates[0];
   this.rebuild();
  }
  disconnectedCallback(){this.controller?.abort();this.ready=false;}
  el(s){return this.querySelector(s);}
  money(n){return new Intl.NumberFormat(this.data.locale||'en',{style:'currency',currency:this.data.currency||'USD'}).format(n/100);}
  stockRate(lines){
   const eligible=lines.filter(l=>String(l.p.id)==='14940217114987');
   return this.s.stock_discount_enabled!==false&&eligible.reduce((n,l)=>n+Number(l.q),0)>=2?Math.max(0,Math.min(100,Number(this.s.stock_discount_percent??10)))/100:0;
  }
  priced(lines,getPrice){
   const rate=this.stockRate(lines);
   return lines.reduce((n,l)=>{const base=getPrice(l)*l.q;return n+base-(String(l.p.id)==='14940217114987'?Math.round(base*rate):0);},0);
  }
  firstOrderOverride(offer=this.offer){
   if(!offer.settings.sub_first_override_enabled)return null;
   const value=String(offer.settings.sub_first_price??'').trim();
   if(!/^\d+(\.\d{1,2})?$/.test(value))return null;
   const cents=Math.round(Number(value)*100);
   return Number.isSafeInteger(cents)?cents:null;
  }
  subscriptionReference(fallback){
   const settings=this.offer.settings,mode=settings.sub_strike_mode||'existing';
   if(mode==='retail')return this.subItems.reduce((n,l)=>n+(l.v?.price||0)*l.q,0);
   if(mode==='custom'){
    const value=String(settings.sub_strike_price||'').trim();
    return /^\d+(\.\d{1,2})?$/.test(value)?Math.round(Number(value)*100):0;
   }
   return fallback;
  }
  showPrice(el,base,total){
   el.replaceChildren();
   if(total<base){const original=document.createElement('s');original.className='hcb__original-price';original.textContent=this.money(base);el.append(original,document.createTextNode(' '));}
   el.append(document.createTextNode(this.money(total)));
  }
  norm(s){return String(s||'').trim().toLowerCase().replace(/\s+/g,' ');}
  format(s,v){return String(s||'').replace(/\{(\w+)\}/g,(m,k)=>v[k]??m);}
  lines(offer=this.offer,mode=this.mode,scent=this.scent){return (mode==='sub'?offer.subProducts:offer.onceProducts).filter(Boolean).map(p=>{const key=mode==='sub'?(scent.settings.sub_match||scent.settings.match):scent.settings.match;const matches=p.fixed?p.variants.filter(v=>String(v.id)===p.fixed.trim()||v.sku===p.fixed.trim()):p.variants.length===1?p.variants:p.variants.filter(v=>this.norm(v.title)===this.norm(key));return {p,v:matches.length===1?matches[0]:undefined,q:p.quantity};});}
  state(offer=this.offer,scent=this.scent){const once=this.lines(offer,'once',scent),sub=this.lines(offer,'sub',scent);return {once,sub,keys:this.common(sub),onceOK:once.length>0&&once.every(l=>l.v?.available&&!l.v.requiresPlan),subAvailable:sub.length>0&&sub.every(l=>l.v?.available)};}
  soldOut(lines){return lines.length>0&&lines.every(l=>!!l.v)&&lines.some(l=>!l.v.available);}
  updateScentAvailability(){
   this.data.scents.forEach(scent=>{
    const st=this.state(this.offer,scent);
    const subOK=st.subAvailable&&st.keys.includes(this.norm(this.offer.settings.cadence));
    const soldOut=!st.onceOK&&!subOK&&(this.soldOut(st.once)||this.soldOut(st.sub));
    const input=this.el('[data-scent][value="'+scent.id+'"]');
    input.closest('.hcb__scent-pill').classList.toggle('is-sold-out',soldOut);
    input.setAttribute('aria-label',scent.settings.label+(soldOut?' — '+this.s.out_of_stock:''));
   });
  }
  common(lines){if(!lines.length||lines.some(l=>!l.v))return [];return [...new Set(lines[0].v.plans.map(p=>this.norm(p.cadence)))].filter(k=>lines.every(l=>l.v.plans.some(p=>this.norm(p.cadence)===k)));}
  plan(l){return l.v?.plans.find(p=>this.norm(p.cadence)===this.cadence);}
  change(e){if(this.busy)return;
   if(e.target.matches('[data-format]')){this.selectFormat(e.target.value);}
   if(e.target.matches('[data-offer]')){const offer=this.formatOffers().find(o=>o.id===e.target.value);if(offer){this.offer=offer;this.rebuild();}}
   if(e.target.matches('[data-scent]')){this.scent=this.data.scents.find(s=>s.id===e.target.value);this.rebuild();}
   if(e.target.matches('[data-purchase]')){this.mode=e.target.value;this.rebuild();}
  }
  rebuild(){
   this.syncFormatControls();
   this.el('[data-intro]').textContent=this.offer.settings.intro_override||this.s.subheading||'';
   const st=this.state();this.onceItems=st.once;this.subItems=st.sub;const keys=st.keys;
   this.cadence=keys.find(k=>k===this.norm(this.offer.settings.cadence));
   this.onceOK=st.onceOK;this.subOK=st.subAvailable&&!!this.cadence;
   if(this.mode==='sub'&&!this.subOK&&this.onceOK)this.mode='once';if(this.mode==='once'&&!this.onceOK&&this.subOK)this.mode='sub';
   this.items=this.mode==='sub'?this.subItems:this.onceItems;
   this.el('[data-offer][value="'+this.offer.id+'"]').checked=true;this.el('[data-scent][value="'+this.scent.id+'"]').checked=true;
   this.el('[data-scent-text]').textContent=this.scent.settings.description;
   this.el('[data-offer-copy]').innerHTML=this.offer.settings.extra_copy||'';
   this.el('[data-sub-copy]').innerHTML=this.offer.settings.sub_copy||'';this.el('[data-once-copy]').innerHTML=this.offer.settings.once_copy||'';
   this.buildGallery();this.update();
  }
  update(){
   const sub=this.mode==='sub';this.items=sub?this.subItems:this.onceItems;
   const onceBase=this.onceItems.reduce((n,l)=>n+(l.v?.price||0)*l.q,0),subBase=this.subOK?this.subItems.reduce((n,l)=>n+this.plan(l).price*l.q,0):0,once=this.priced(this.onceItems,l=>l.v?.price||0),recurring=this.subOK?this.priced(this.subItems,l=>this.plan(l).price):0,override=this.subOK?this.firstOrderOverride():null,first=override??recurring,total=sub?first:once;
   this.showPrice(this.el('[data-once-price]'),onceBase,once);this.showPrice(this.el('[data-sub-price]'),this.subscriptionReference(subBase),first);
   this.el('[data-sub-price-label]').textContent=override!==null?this.offer.settings.sub_first_label:this.s.first_order;
   this.el('[data-once-price]').closest('.hcb__price').hidden=!this.onceOK;
   this.el('[data-sub-price]').closest('.hcb__price').hidden=!this.subOK;
   this.el('[data-purchase][value="once"]').disabled=!this.onceOK||this.busy;this.el('[data-purchase][value="sub"]').disabled=!this.subOK||this.busy;
   this.el('[data-purchase][value="'+this.mode+'"]').checked=true;
   this.el('[data-sub-card]').classList.toggle('is-selected',sub);this.el('[data-once-card]').classList.toggle('is-selected',!sub);
   this.el('[data-savings]').textContent=this.subOK&&this.onceOK&&this.offer.settings.same_contents&&once>first?this.format(this.s.savings,{amount:this.money(once-first),percent:Math.floor((once-first)*100/once),reference:this.money(once)}):'';
   const terms=sub&&this.subOK?this.subItems.map(l=>{const p=this.plan(l),count=p.rules?.[0]?.order_count,last=p.adjustments?.at(-1)?.price??p.price;const v={product:l.p.title,quantity:l.q,price:this.money(p.price*l.q-(String(l.p.id)==='14940217114987'?Math.round(p.price*l.q*this.stockRate(this.subItems)):0)),renewal:this.money(last*l.q-(String(l.p.id)==='14940217114987'?Math.round(last*l.q*this.stockRate(this.subItems)):0)),cadence:p.cadence,count};return this.format(p.adjustments?.length>1&&count?this.s.intro_terms:this.s.renewal_terms,v);}).join(' '):'';
   let displayTerms=terms;
   if(sub&&this.subOK&&override!==null){
    const schedule=this.subItems.map(l=>{
     const p=this.plan(l),count=Number(p.rules?.[0]?.order_count),last=p.adjustments?.at(-1)?.price??p.price;
     const amount=price=>price*l.q-(String(l.p.id)==='14940217114987'?Math.round(price*l.q*this.stockRate(this.subItems)):0);
     const phased=p.adjustments?.length>1&&count>0,remaining=phased&&count>1;
     return this.format(remaining?this.s.intro_terms:this.s.renewal_terms,{product:l.p.title,quantity:l.q,price:this.money(amount(phased&&!remaining?last:p.price)),renewal:this.money(amount(last)),cadence:p.cadence,count:count-1});
    }).join(' ');
    displayTerms=this.format(this.offer.settings.sub_first_terms,{price:this.money(first),schedule});
   }
   this.el('[data-subterms]').textContent=displayTerms;
   this.el('[data-pack-mode]').textContent=this.format(this.s.pack_price_note,{purchase:sub?this.s.subscribe:this.s.once});
   this.formatOffers().forEach(o=>{const st=this.state(o),lines=sub?st.sub:st.once,key=st.keys.find(k=>k===this.norm(o.settings.cadence));const ok=sub?st.subAvailable&&!!key:st.onceOK;const price=ok?lines.reduce((n,l)=>n+(sub?l.v.plans.find(p=>this.norm(p.cadence)===key).price:l.v.price)*l.q,0):0;const priceEl=this.el('[data-pack-price="'+o.id+'"]');if(ok){const discounted=this.priced(lines,l=>sub?l.v.plans.find(p=>this.norm(p.cadence)===key).price:l.v.price);const manual=sub?this.firstOrderOverride(o):null;this.showPrice(priceEl,price,manual??discounted);if(manual!==null){const label=document.createElement('small');label.textContent=o.settings.sub_first_label;priceEl.append(label);}if(manual===null&&discounted<price){const saving=document.createElement('small');saving.className='hcb__stock-saving';saving.textContent=this.format(this.s.stock_savings_label,{amount:this.money(price-discounted),percent:Math.round(this.stockRate(lines)*100)});priceEl.append(saving);}}else{priceEl.textContent=this.soldOut(lines)?this.s.out_of_stock:this.s.unavailable;}this.el('[data-pack-contents="'+o.id+'"]').textContent=sub?(o.settings.sub_contents||o.settings.contents):o.settings.contents;});
   this.valid=sub?this.subOK:this.onceOK;const soldOut=!this.valid&&this.soldOut(this.items);this.el('[data-submit]').classList.toggle('is-sold-out',soldOut);this.el('[data-submit]').disabled=!this.valid||!!this.busy;this.el('[data-submit]').textContent=this.busy?this.s.adding:this.valid?this.format(sub?this.s.sub_cta:this.s.once_cta,{price:this.money(total)}):soldOut?this.s.out_of_stock:this.s.unavailable;
   this.el('[data-availability]').textContent=soldOut?'':!this.valid?this.s.unavailable:!this.subOK&&!this.soldOut(this.subItems)?this.s.no_sub:!this.onceOK&&!this.soldOut(this.onceItems)?this.s.sub_only:'';
   this.updateScentAvailability();
   this.querySelectorAll('[data-offer],[data-scent]').forEach(e=>e.disabled=!!this.busy);
   this.syncFormatControls();
  }
  buildGallery(){
   const matched=this.data.images.filter(i=>(!i.format||i.format==='all'||i.format===this.factor)&&(!i.offer||i.offer===this.offer.settings.key)&&(!i.scent||i.scent===this.scent.settings.key)&&(!i.purchase||i.purchase==='both'||i.purchase===this.mode));const hero=matched.find(i=>i.hero);
   this.gallery=hero?[hero,...matched.filter(i=>i!==hero)]:[{composite:true,alt:this.offer.settings.contents,caption:this.offer.settings.caption},...matched];
   this.el('[data-composite]').replaceChildren(...this.items.filter(l=>l.v).map(l=>{const f=document.createElement('figure'),im=document.createElement('img'),cap=document.createElement('figcaption');im.src=l.v.image||l.p.image||'';im.alt=l.p.title+' — '+l.v.title;im.width=600;im.height=600;cap.textContent=l.q+' × '+l.p.title;f.append(im,cap);return f;}));
   this.el('[data-thumbs]').replaceChildren(...this.gallery.map((i,n)=>{const b=document.createElement('button');b.type='button';b.className='hcb__thumbnail';b.dataset.slide=n;b.setAttribute('aria-label',this.format(this.s.photo_label,{number:n+1}));if(i.composite){b.textContent=this.s.bundle_image_label;b.classList.add('hcb__thumbtext');}else{const im=document.createElement('img');im.src=i.src;im.alt='';im.width=120;im.height=120;b.append(im);}return b;}));this.show(0);
  }
  show(n){this.slide=(n+this.gallery.length)%this.gallery.length;const i=this.gallery[this.slide];this.el('[data-composite]').hidden=!i.composite;this.el('[data-image]').hidden=!!i.composite;if(!i.composite){this.el('[data-image]').src=i.src;this.el('[data-image]').alt=i.alt||this.s.image_alt;}this.el('[data-caption]').textContent=i.caption||'';this.el('[data-count]').textContent=(this.slide+1)+' / '+this.gallery.length;this.querySelectorAll('[data-slide]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.slide)===this.slide)));}
  click(e){const b=e.target.closest('[data-slide],[data-next],[data-prev]');if(!b||!this.gallery)return;this.show(b.hasAttribute('data-slide')?Number(b.dataset.slide):this.slide+(b.hasAttribute('data-next')?1:-1));}
  async submit(e){
   e.preventDefault();e.stopImmediatePropagation();if(this.busy||!this.valid)return;
   const sub=this.mode==='sub',items=this.items.map(l=>{const item={id:l.v.id,quantity:l.q};if(sub)item.selling_plan=this.plan(l).id;return item;});
   this.busy=true;this.update();this.el('[data-error]').hidden=true;this.el('[data-submit]').setAttribute('aria-busy','true');
   try{
    const r=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const body=await r.json();
    if(!r.ok)throw new Error(typeof body.description==='string'?body.description:this.s.error);
    try{
     if(typeof window.upcartOpenCart!=='function')throw new Error('Upcart unavailable');
     if(typeof window.upcartRefreshCart==='function')await window.upcartRefreshCart();
     await window.upcartOpenCart();
    }catch(cartError){
     this.el('[data-error]').textContent=this.s.cart_added_notice;
     this.el('[data-error]').hidden=false;
    }
   }catch(err){
    this.el('[data-error]').textContent=err.message||this.s.error;
    this.el('[data-error]').hidden=false;
   }finally{
    this.busy=false;this.update();this.el('[data-submit]').removeAttribute('aria-busy');
   }
  }
 });
}



  } catch(e) { console.error(e); }
})();
})();
